import { Tooltip } from "@mui/material";

export const Buttons = (props) => {
  const {
    justIcon = false,
    title = null,
    name = null,
    icon = null,
    icon2 = null,
    handleClick = () => false,
    disabled = false,
  } = props;

  return (
    <Tooltip title={title}>
      {justIcon ? (
        <button
          className="flex justify-center items-center w-12 h-12 rounded-full  hover:!bg-[var(--primary-color)] hover:text-white text-gray-500 shrink-0 outline-none"
          onClick={handleClick}
          disabled={disabled}
        >
          {icon}
        </button>
      ) : (
        <button
          className="text-sm bg-white hover:!bg-[var(--primary-color)] text-gray-500 hover:text-white rounded-lg flex items-center gap-1 p-2 shrink-0 border border-gray-100"
          onClick={handleClick}
          disabled={disabled}
        >
          {icon}
          <span>{name}</span>
          {icon2}
        </button>
      )}
    </Tooltip>
  );
};
